const OperatorIcon = ({ phoneNumber }) => {
  if (!phoneNumber) return null;

  const operatorData = [
    {
      prefixes: [
        "0910",
        "0911",
        "0912",
        "0913",
        "0914",
        "0915",
        "0916",
        "0917",
        "0918",
        "0919",
        "0990",
        "0991",
        "0992",
        "0993",
      ],
      name: "همراه اول",
      logo: "mci.png",
    },
    {
      prefixes: [
        "0930",
        "0933",
        "0935",
        "0936",
        "0937",
        "0938",
        "0939",
        "0901",
        "0902",
        "0903",
        "0904",
        "0905",
        "0941",
      ],
      name: "ایرانسل",
      logo: "irancell.png",
    },
    {
      prefixes: ["0920", "0921", "0922"],
      name: "رایتل",
      logo: "rightel.png",
    },
    { prefixes: ["0934"], name: "تله‌کیش", logo: "telekish.png" },
    {
      prefixes: ["099999", "09999"],
      name: "سامانتل",
      logo: "samantel.png",
    },
    {
      prefixes: ["099810", "099811", "099812", "099814", "099815"],
      name: "شاتل",
      logo: "shatel.png",
    },
    { prefixes: ["0999"], name: "آپتل", logo: "aptel.png" },
    { prefixes: ["0932"], name: "تالیا", logo: "taliya.png" },
  ];

  const getOperator = () => {
    for (const operator of operatorData)
      for (const prefix of operator.prefixes)
        if (phoneNumber.startsWith(prefix)) return operator;

    return;
  };

  const operator = getOperator();

  if (!operator) return null;

  return (
    <span className="position-absolute end-0 top-50 translate-middle-y me-16 bg-white rounded-3">
      <img
        src={`/assets/images/operator/${operator.logo}`}
        alt={operator.name}
        style={{ width: "auto", height: 35 }}
      />
    </span>
  );
};

export default OperatorIcon;
